import axios from "./httpClient";

/**
 * Trigger an Entry Screen Agent ("Embassy AI Agent") run for a DS160 applicant.
 * The body is intentionally empty: the backend derives every AVITS parameter from
 * the applicant and reuses the applicant's existing embassy account password.
 *
 * @param {string} applicantId - DS160 applicant id.
 * @returns {Promise} Axios response: { success, data: { runId, status, pollUrl } }.
 */
export function triggerEntryScreenAgentRunApi(applicantId) {
  return axios.post(`/entry-screen-agent/ds160/${applicantId}/run`);
}

/**
 * Fetch a run's LIVE status from the backend's vendor proxy (persists nothing).
 *
 * @param {string} applicantId - DS160 applicant id that owns the run.
 * @param {string} runId - Entry Screen Agent run id.
 * @returns {Promise} Axios response: { success, data: { status, currentStep, totalSteps,
 *   stepResults, extractedData, finalScreenshot, errorMessage, warnings } }.
 */
export function getEntryScreenAgentRunStatusApi(applicantId, runId) {
  return axios.get(
    `/entry-screen-agent/ds160/${applicantId}/runs/${runId}/status`,
  );
}
